var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5642 14.5612C15.5775 13.6841 14.3032 13.1996 12.983 13.1996C11.6628 13.1996 10.3885 13.6841 9.40172 14.5612M19.4259 11.6995C17.6783 10.0653 15.3751 9.15625 12.9825 9.15625C10.5899 9.15625 8.28667 10.0653 6.53906 11.6995",
    fill: "#1E61DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5642 14.5612C15.5775 13.6841 14.3032 13.1996 12.983 13.1996C11.6628 13.1996 10.3885 13.6841 9.40172 14.5612M19.4259 11.6995C17.6783 10.0653 15.3751 9.15625 12.9825 9.15625C10.5899 9.15625 8.28667 10.0653 6.53906 11.6995",
    stroke: "#1E61DC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9738 8.53535C19.5003 6.32881 16.3015 5.10938 12.9869 5.10938C9.67225 5.10938 6.47346 6.32881 4 8.53535",
    fill: "#1E61DC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9738 8.53535C19.5003 6.32881 16.3015 5.10938 12.9869 5.10938C9.67225 5.10938 6.47346 6.32881 4 8.53535",
    stroke: "#1E61DC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9844 19.5C12.6877 19.5 12.3977 19.412 12.151 19.2472C11.9043 19.0824 11.7121 18.8481 11.5986 18.574C11.485 18.2999 11.4553 17.9983 11.5132 17.7074C11.5711 17.4164 11.7139 17.1491 11.9237 16.9393C12.1335 16.7296 12.4008 16.5867 12.6917 16.5288C12.9827 16.4709 13.2843 16.5006 13.5584 16.6142C13.8325 16.7277 14.0668 16.92 14.2316 17.1666C14.3964 17.4133 14.4844 17.7033 14.4844 18C14.4844 18.3978 14.3263 18.7794 14.045 19.0607C13.7637 19.342 13.3822 19.5 12.9844 19.5Z",
    fill: "#1E61DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/Wifi.1508e7ef26aa7dba6904fb2612933917.svg";
export { ForwardRef as ReactComponent };